import { EmployeeLicenseUsageComponent } from './components/employee-license-usage.component';
import { EmployeeLicenseUpgradeComponent } from './components/employee-license-upgrade.component';
import { CountryCodeResolver } from './../employees/services/employeeWorkExperience.resolver.service';
import { CustomizeHomePageService } from './../customize-homepage/customize-homepage.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdsExposureAllowlistComponent } from '../safety-data-sheet/components/sds-exposure-allowlist.component';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { NgxUploaderCompatModule } from '../../_services/primeng-uploader';
import { EmployeeCourseServices } from './../employees/services/employeecourse.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BusinessLinksEditResolver,
  BusinessLinksListResolver,
  PortalBusinessLinksListResolver
} from './services/businessLinks.resolver.service';
import { BusinessHomepageService } from './services/businessHomepage.service';
import { BusinessLinksService } from './services/businessLinks.service';
import { BusinessAbsenceService } from './services/businessAbsenceService';
import { BusinessSettingService } from './services/businessSetting.service';
import { FeaturesBaseServices } from './../features/services/features-base.services';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';
import {
  BusinessEditResolver,
  BusinessAgreementResolver,
  BusinessEquipmentResolver,
  BusinessAbsenceCodeByBusinessResolver,
  UserDropDownResolver,
  LanguageResolver,
  SettingByBusinessResolver,
  HseManagerResolver,
  UserByBusinessResolver,
  BusinessCourseResolverByBusiness,
  BusinessCourseEditResolver,
  BusinessCourseListResolver,
  EmployeeContactUserResolver,
  EmployeeCountResolver,
  CompanyNameResolver,
  BusinessUserEditResolver,
  BusinessCategoryResolver,
  UserDropDownResolverForBusiness,
  PortalBusinessResolver,
  BusinessLogListResolver,
  PortalContactListResolver,
  BusinessCacheResolver,
  BusinessDepartmentResolver,
  BusinessDataResolver,
  LicenseCategoryResolver,
  BusinessDataFeatureResolver,
  BusinessUsersCountResolver,
  BusinessEmployeesCountResolver,
  ContactsByBusinessResolver,
  HavePersonalDelegateResolver,
  EmployeeOnlyResolver,
  BusinessDetailsChildResolver
} from './services/business.resolver.service';

import { AppSharedModule } from './../shared/appShared.module';
import { BusinessServices } from './services/business.services';
import { BusinessCategoryService } from './services/businessCategory.service';
import { BusinessEquipmentService } from './services/businessEquipment.service';
import { BusinessesComponent } from './businesses.component';
import { UserModule } from './../users/user.module';
import {
  BusinessListComponent,
  BusinessImportComponent,
  BusinessWizardComponent,
  BusinessDetailsComponent,
  BusinessUsersComponent,
  BusinessFeaturesComponent,
  BusinessHomepageComponent,
  BusinessLicenseComponent,
  BusinessSettingsComponent,
  BusinessAbsenceCodesComponent,
  BusinessEquipmentsComponent,
  BusinessUsersEditComponent,
  BusinessLinksComponent,
  BusinessCourseListComponent,
  BusinessLogComponent
} from './components/';
import { BusinessSignedService } from './services/businessSigned.service';
import { BusinessSignedUsersListResolver } from './services/businessSigned.resolver.service';
// import { ApplicationDefaultVideoResolver } from '../customize-homepage/customize-homepage.resolver';
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { BusinessLogService } from './services/businessLog.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { BusinessFeatureListResolver } from '../license-agreement/services/license-agreement.resolver';
import { FeaturesAndRightsComponent } from '../shared/components/featuresAndRights.component';
import { EcplDocumentExplorerModule } from '../../shared/ecpl-document-explorer';
import { EcplTabNavigationModule } from '../../shared/ecpl-tab-navigation/ecpl-tab-navigation.module';
import { DateRangeWithModule } from '../shared/directives/date-range/date-range-with.module';
import { BusinessSettingsPersonDialogComponent } from './components/business-settings-person-dialog.component';

@NgModule({ exports: [
        BusinessesComponent,
        BusinessListComponent,
        BusinessImportComponent,
        BusinessWizardComponent,
        BusinessDetailsComponent,
        BusinessUsersComponent,
        BusinessFeaturesComponent,
        BusinessHomepageComponent,
        BusinessLicenseComponent,
        BusinessSettingsComponent,
        BusinessEquipmentsComponent,
        BusinessAbsenceCodesComponent,
        BusinessUsersEditComponent,
        BusinessLinksComponent,
        FeaturesAndRightsComponent,
        BusinessCourseListComponent,
        BusinessLogComponent
  ],
    declarations: [
    BusinessesComponent,
    BusinessListComponent,
    BusinessImportComponent,
    BusinessWizardComponent,
    BusinessDetailsComponent,
    BusinessUsersComponent,
    BusinessFeaturesComponent,
    BusinessHomepageComponent,
    BusinessLicenseComponent,
    BusinessSettingsComponent,
    BusinessEquipmentsComponent,
    BusinessAbsenceCodesComponent,
    BusinessUsersEditComponent,
    BusinessLinksComponent,
    FeaturesAndRightsComponent,
    BusinessCourseListComponent,
    BusinessLogComponent
  ], imports: [CommonModule,
        EmployeeLicenseUsageComponent,
        EmployeeLicenseUpgradeComponent,
        PasswordValidatorModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        AppSharedModule,
        TranslatePipe, TranslateDirective,
        UserModule,
        ConfirmDialogModule,
        DialogModule,
        TableModule,
        PaginatorModule,
        CheckboxModule,
        MultiSelectModule,
        TooltipModule,
        DatePickerModule,
        EditorModule,
        ContextMenuModule,
        MenuModule,
        SelectModule,
        TextareaModule,
        InputTextModule,
        TranslatePipe, TranslateDirective,
        RouterModule,
        ButtonModule,
        TabsModule,
        NgxUploaderCompatModule,
        ToggleSwitchModule,
        EcplDocumentExplorerModule,
        KubaExportModule,
        EcplTabNavigationModule,
        DateRangeWithModule,
        SdsExposureAllowlistComponent,
        BusinessSettingsPersonDialogComponent
  ],

  providers: [
    BusinessServices,
    BusinessCategoryService,
    BusinessEquipmentService,
    BusinessSettingService,
    BusinessAbsenceService,
    BusinessEditResolver,
    BusinessAgreementResolver,
    BusinessLinksListResolver,
    BusinessLinksEditResolver,
    BusinessLinksService,
    BusinessHomepageService,
    EmployeeCourseServices,
    BusinessEquipmentResolver,
    BusinessAbsenceCodeByBusinessResolver,
    UserDropDownResolver,
    LanguageResolver,
    SettingByBusinessResolver,
    HseManagerResolver,
    UserByBusinessResolver,
    BusinessUserEditResolver,
    BusinessCategoryResolver,
    BusinessSignedService,
    BusinessSignedUsersListResolver,
    UserDropDownResolverForBusiness,
    FeaturesBaseServices,
    CustomizeHomePageService,
    // ApplicationDefaultVideoResolver,
    CountryCodeResolver,
    PortalBusinessResolver,
    BusinessLogService,
    BusinessLogListResolver,
    PortalContactListResolver,
    EmployeeContactUserResolver,
    BusinessCourseEditResolver,
    BusinessCourseListResolver,
    BusinessCourseResolverByBusiness,
    EmployeeCountResolver,
    CompanyNameResolver,
    BusinessCacheResolver,
    BusinessDepartmentResolver,
    BusinessDataResolver,
    LicenseCategoryResolver,
    BusinessDataFeatureResolver,
    BusinessUsersCountResolver,
    BusinessEmployeesCountResolver,
    ContactsByBusinessResolver,
    HavePersonalDelegateResolver,
    BusinessFeatureListResolver,
    PortalBusinessLinksListResolver,
    EmployeeOnlyResolver,
    BusinessDetailsChildResolver,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class BusinessesModule {}
